export default __webpack_public_path__ + "static/media/02_south_flower_b2.24714f72.mp4";